// navigation.js - Navigation system with better organization

import { langManager } from '../lang/langManager.js';
import { log } from '../utils/logging.js';

// ============================================================================
// Constants
// ============================================================================

const INTERMEDIATE_ASPECT_RATIO = 1.55;

// ============================================================================
// HTML Template Builder
// ============================================================================

class NavigationTemplateBuilder {
  buildMobileHTML() {
    return `
      <nav class="nav-sidebar">
        <div class="home-icon-container">
          <div class="section-icon-wrapper home-icon-trigger" data-section="home">
            <img src="/icones/Home_icon.webp" alt="Home" class="section-icon">
            <span class="section-label">Home</span>
          </div>

          ${this._buildSectionIcons()}
        </div>
        
        <div class="nav-wrapper portrait-utils">
          ${this._buildLanguageSwitcher()}
          ${this._buildContactMenu()}
        </div>
        </nav>
        
        <div class="nav-utilities">
        <div class="nav-wrapper landscape-utils">
        ${this._buildLanguageSwitcher()}
        ${this._buildContactMenu()}
        </div>
        </div>
        
        ${this._buildPersistentImpressum()}  
      ${this._buildImpressumModal()}    
      ${this._buildDatenschutzModal()}  `;
  }

  buildDesktopHTML() {
    return `
      <nav class="nav-sidebar">
        <div class="home-icon-container">
          <div class="section-icon-wrapper home-icon-trigger" data-section="home">
            <img src="/icones/Home_icon.webp" alt="Home" class="section-icon">
            <span class="section-label">Home</span>
          </div>
          
          ${this._buildSectionIcons()}
        </div>
        
        <div class="nav-wrapper portrait-utils">
          ${this._buildLanguageSwitcher()}
          ${this._buildContactMenu()}
        </div>
        </nav>
        
        <div class="nav-utilities">
        <div class="nav-wrapper landscape-utils">
        ${this._buildLanguageSwitcher()}
        ${this._buildContactMenu()}
        </div>
        </div>
        
        ${this._buildPersistentImpressum()}  
      ${this._buildImpressumModal()}
      ${this._buildDatenschutzModal()}
    `;
  }

  _buildSectionIcons() {
    const sections = [
      { id: 'market', i18n: 'navMarket', label: 'Market' },
      { id: 'catering', i18n: 'navCatering', label: 'Catering' },
      { id: 'boutique', i18n: 'navBoutique', label: 'Boutique' },
      { id: 'games', i18n: 'navGames', label: 'Games' },
      { id: 'about', i18n: 'navAbout', label: 'About' }
    ];

    return `
      <div class="section-icons">
        ${sections
          .map(
            section => `
          <div class="section-icon-wrapper" data-section="${section.id}">
            <img src="/icones/${section.label}_icon.webp" alt="${section.label}" class="section-icon">
            <span class="section-label" data-i18n="${section.i18n}">${section.label}</span>
          </div>
        `
          )
          .join('')}
      </div>
    `;
  }

  _buildLanguageSwitcher() {
    return `
      <div class="lang-wrapper">
        <img class="lang-img lang-button" src="/icones/en_active.webp" alt="Language">
        <div class="lang-zone lang-de" data-lang="de"></div>
        <div class="lang-zone lang-fr" data-lang="fr"></div>
        <div class="lang-zone lang-en" data-lang="en"></div>
      </div>
    `;
  }

  _buildContactMenu() {
    return `
    <div class="contact-wrapper">
      <img class="contact-toggle contact-button" src="/icones/contact.webp" alt="Contact">
      <div class="contact-menu">
        <a href="mailto:info@bubar.eu">info@bubar.eu</a>
        <div>+49 1520 464 2823</div>
        <div class="impressum-link" data-i18n="impressum"></div>
        <div class="datenschutz-link" data-i18n="privacy"></div>
      </div>
    </div>
  `;
  }

  _buildImpressumModal() {
    return `
    <div id="impressum-modal">
      <div class="impressum-content">
        <button class="modal-close" aria-label="Close">&times;</button>
        <h1 data-i18n="impressumTitle"></h1>
        <div data-i18n-html="impressumContent"></div>
      </div>
    </div>
  `;
  }

  _buildPersistentImpressum() {
    return `
    <div class="impressum-persistent impressum-link" >Impressum</div>
  `;
  }

  _buildDatenschutzModal() {
    return `
    <div id="datenschutz-modal">
      <div class="datenschutz-content">
        <button class="modal-close" aria-label="Close">&times;</button>
        
        <div class="privacy-header">
          <h2 data-i18n="privacyTitle"></h2>
        </div>

        <div class="privacy-scroll-container">
          <section class="privacy-section">
            <h3 data-i18n="privacyS1Title"></h3>
            <div data-i18n-html="privacyS1General"></div>
            <div data-i18n-html="privacyS1Collection"></div>
          </section>

          <section class="privacy-section">
            <h3 data-i18n="privacyS2Title"></h3>
            <div data-i18n-html="privacyS2Content"></div>
          </section>

          <section class="privacy-section">
            <h3 data-i18n="privacyS3Title"></h3>
            <div data-i18n-html="privacyS3General"></div>
            <div data-i18n-html="privacyS3Controller"></div>
            <div data-i18n-html="privacyS3Storage"></div>
            <div data-i18n-html="privacyS3Legal"></div>
            <div data-i18n-html="privacyS3Rights"></div>
            <div data-i18n-html="privacyS3Encryption"></div>
          </section>

          <section class="privacy-section">
            <h3 data-i18n="privacyS4Title"></h3>
            <div data-i18n-html="privacyS4Logs"></div>
            <div data-i18n-html="privacyS4Form"></div>
          </section>

          <section class="privacy-section">
            <h3 data-i18n="privacyS5Title"></h3>
            <div data-i18n-html="privacyS5Content"></div>
          </section>

          <section class="privacy-section">
            <h3 data-i18n="privacyS6Title"></h3>
            <div data-i18n-html="privacyS6Turnstile"></div>
            <div data-i18n-html="privacyS6Umami"></div>
          </section>
        </div>
      </div>
    </div>
  `;
  }
}

// ============================================================================
// Image Preloader
// ============================================================================

class NavigationImagePreloader {
  preload() {
    const imageSources = [
      '/icones/Home_icon.webp',
      '/icones/About_icon.webp',
      '/icones/Market_icon.webp',
      '/icones/Catering_icon.webp',
      '/icones/Games_icon.webp',
      '/icones/Boutique_icon.webp',
      '/icones/en_active.webp',
      '/icones/de_active.webp',
      '/icones/fr_active.webp',
      '/icones/contact.webp'
    ];

    const imagePromises = imageSources.map(src => {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = () => resolve();
        img.src = src;
      });
    });

    return Promise.all(imagePromises);
  }
}

// ============================================================================
// Section Manager
// ============================================================================

class SectionManager {
  getCurrentSection() {
    const match = document.body.className.match(/page-(\w+)/);
    return match ? match[1] : 'home';
  }

  updateActiveSectionIcon(activeSection) {
    document.querySelectorAll('.section-icon-wrapper').forEach(wrapper => {
      const shouldBeActive = wrapper.dataset.section === activeSection;
      const isActive = wrapper.classList.contains('active');

      // Only update if state needs to change (prevents flicker from redundant DOM updates)
      if (shouldBeActive && !isActive) {
        wrapper.classList.add('active');
      } else if (!shouldBeActive && isActive) {
        wrapper.classList.remove('active');
      }
    });
  }

  updateSectionIconLanguage(lang) {
    document.querySelectorAll('.section-label').forEach(label => {
      const i18nKey = label.dataset.i18n;
      if (i18nKey) {
        const translatedText = langManager.getText(i18nKey);
        if (translatedText) {
          label.textContent = translatedText;
        }
      }
    });
  }
}

// ============================================================================
// Home Page Visibility Manager
// ============================================================================

class HomePageVisibilityManager {
  constructor(sectionManager) {
    this.sectionManager = sectionManager;
    this.sceneLoadedHandler = null;
  }

  setup() {
    this.sceneLoadedHandler = event => {
      // Get scene name from event detail or fallback to current section
      const sceneName = event.detail?.sceneName || this.sectionManager.getCurrentSection();
      this.update(sceneName);
    };
    window.addEventListener('scene-loaded', this.sceneLoadedHandler);

    this.update();
  }

  cleanup() {
    if (this.sceneLoadedHandler) {
      window.removeEventListener('scene-loaded', this.sceneLoadedHandler);
      this.sceneLoadedHandler = null;
    }
  }

  update(sceneName = null) {
    const currentSection = sceneName || this.sectionManager.getCurrentSection();
    const isHome = currentSection === 'home';

    // Update navbar visibility
    const navbar = document.querySelector('.nav-sidebar');
    if (navbar) {
      if (isHome) {
        navbar.classList.add('on-home-page');
      } else {
        navbar.classList.remove('on-home-page');
      }
    }
  }
}

// ============================================================================
// Section Icons Handler
// ============================================================================

class SectionIconsHandler {
  constructor(sectionManager) {
    this.sectionManager = sectionManager;
    this.pendingSection = null;
    this.clickHandlers = new Map();
    this.languageChangeHandler = null;
    this.sceneLoadedHandler = null;
  }

  setup() {
    const iconWrappers = document.querySelectorAll('.section-icon-wrapper');
    if (!iconWrappers.length) return;

    this.sectionManager.updateActiveSectionIcon(this.sectionManager.getCurrentSection());

    iconWrappers.forEach(wrapper => {
      const clickHandler = () => this._handleClick(wrapper);
      wrapper.addEventListener('click', clickHandler);
      this.clickHandlers.set(wrapper, clickHandler);
    });

    this.languageChangeHandler = e => {
      this.sectionManager.updateSectionIconLanguage(e.detail.lang);
    };
    window.addEventListener('languageChanged', this.languageChangeHandler);

    this.sceneLoadedHandler = e => {
      const sceneName = e.detail?.sceneName || 'home';
      if (this.pendingSection && sceneName !== this.pendingSection) return;
      this.sectionManager.updateActiveSectionIcon(sceneName);
      if (this.pendingSection === sceneName) this.pendingSection = null;
    };
    window.addEventListener('scene-loaded', this.sceneLoadedHandler);
  }

  cleanup() {
    // Remove click handlers
    this.clickHandlers.forEach((handler, wrapper) => {
      wrapper.removeEventListener('click', handler);
    });
    this.clickHandlers.clear();

    // Remove global handlers
    if (this.languageChangeHandler) {
      window.removeEventListener('languageChanged', this.languageChangeHandler);
      this.languageChangeHandler = null;
    }
    if (this.sceneLoadedHandler) {
      window.removeEventListener('scene-loaded', this.sceneLoadedHandler);
      this.sceneLoadedHandler = null;
    }
  }

  _handleClick(wrapper) {
    const section = wrapper.dataset.section;
    const current = this.sectionManager.getCurrentSection();

    if (section === current) return;

    log('[DEBUG] Click handler: clicked section:', section, 'current:', current);
    const navbar = document.querySelector('.nav-sidebar');
    if (navbar) {
      log(
        '[DEBUG] Click handler: navbar opacity:',
        navbar.style.opacity,
        'classList:',
        Array.from(navbar.classList)
      );
    }

    this.pendingSection = section;
    this.sectionManager.updateActiveSectionIcon(section);

    if (section === 'home') {
      window.dispatchEvent(new CustomEvent('navigate-home', { detail: { scene: 'home' } }));
    } else {
      window.dispatchEvent(new CustomEvent('navigate-section', { detail: { section } }));
    }
  }
}

// ============================================================================
// Mobile Home Button Handler
// ============================================================================

class MobileHomeButtonHandler {
  constructor() {
    this.clickHandler = null;
  }

  setup() {
    const homeIcon = document.querySelector('.home-icon-trigger');

    if (homeIcon) {
      this.clickHandler = () => {
        window.dispatchEvent(new CustomEvent('navigate-home', { detail: { scene: 'home' } }));
      };
      homeIcon.addEventListener('click', this.clickHandler);
    }
  }

  cleanup() {
    if (this.clickHandler) {
      const homeIcon = document.querySelector('.home-icon-trigger');
      if (homeIcon) {
        homeIcon.removeEventListener('click', this.clickHandler);
      }
      this.clickHandler = null;
    }
  }
}

// ============================================================================
// Language Switcher
// ============================================================================

class LanguageSwitcher {
  constructor() {
    this.clickHandlers = new Map();
    this.languageChangeHandler = null;
  }

  setup(reloadOnChange = false) {
    const langImgs = document.querySelectorAll('.lang-img');
    const langZones = document.querySelectorAll('.lang-zone');
    if (!langZones.length) return;

    // Set initial icon based on current language
    const currentLang = langManager.getCurrentLanguage();
    langImgs.forEach(img => {
      img.src = `/icones/${currentLang}_active.webp`;
    });

    langZones.forEach(zone => {
      const clickHandler = e => {
        e.stopPropagation();
        const lang = zone.dataset.lang;
        langManager.setLanguage(lang);

        langImgs.forEach(img => {
          img.src = `/icones/${lang}_active.webp`;
        });

        if (reloadOnChange) location.reload();
      };
      zone.addEventListener('click', clickHandler);
      this.clickHandlers.set(zone, clickHandler);
    });

    this.languageChangeHandler = e => {
      langImgs.forEach(img => {
        img.src = `/icones/${e.detail.lang}_active.webp`;
      });
    };
    window.addEventListener('languageChanged', this.languageChangeHandler);
  }

  cleanup() {
    // Remove click handlers
    this.clickHandlers.forEach((handler, zone) => {
      zone.removeEventListener('click', handler);
    });
    this.clickHandlers.clear();

    // Remove language change handler
    if (this.languageChangeHandler) {
      window.removeEventListener('languageChanged', this.languageChangeHandler);
      this.languageChangeHandler = null;
    }
  }
}

// ============================================================================
// Contact Menu Handler
// ============================================================================

class ContactMenuHandler {
  constructor() {
    this.toggleClickHandlers = new Map();
    this.documentClickHandler = null;
  }

  setup() {
    const contactToggles = document.querySelectorAll('.contact-toggle');

    contactToggles.forEach(toggle => {
      const menu = toggle.nextElementSibling;

      const clickHandler = e => {
        e.stopPropagation();

        document.querySelectorAll('.contact-menu').forEach(m => {
          if (m !== menu) m.classList.remove('open');
        });

        menu.classList.toggle('open');
      };

      toggle.addEventListener('click', clickHandler);
      this.toggleClickHandlers.set(toggle, clickHandler);
    });

    this.documentClickHandler = e => {
      document.querySelectorAll('.contact-menu').forEach(menu => {
        if (!menu.parentElement?.contains(e.target)) {
          menu.classList.remove('open');
        }
      });
    };
    document.addEventListener('click', this.documentClickHandler);
  }

  cleanup() {
    // Remove toggle handlers
    this.toggleClickHandlers.forEach((handler, toggle) => {
      toggle.removeEventListener('click', handler);
    });
    this.toggleClickHandlers.clear();

    // Remove document click handler
    if (this.documentClickHandler) {
      document.removeEventListener('click', this.documentClickHandler);
      this.documentClickHandler = null;
    }
  }
}

// ============================================================================
// Impressum Modal Handler
// ============================================================================

class ImpressumModalHandler {
  constructor(templateBuilder) {
    this.templateBuilder = templateBuilder;
    this.linkClickHandlers = new Map();
    this.languageChangeHandler = null;
    this.closeButtonHandler = null;
    this.modalClickHandler = null;
    this.keydownHandler = null;
  }

  setup() {
    this._setupModal();

    // Rebuild modal content when language changes
    this.languageChangeHandler = () => {
      this._rebuildModal();
    };
    window.addEventListener('languageChanged', this.languageChangeHandler);
  }

  cleanup() {
    if (this.languageChangeHandler) {
      window.removeEventListener('languageChanged', this.languageChangeHandler);
      this.languageChangeHandler = null;
    }
    // Remove modal listeners
    this._cleanupCloseHandlers();
    this.linkClickHandlers.clear();
  }

  _rebuildModal() {
    const modal = document.getElementById('impressum-modal');
    if (!modal) return;
    langManager.updatePageText();
  }

  _setupModal() {
    // Clean up old links first
    this.linkClickHandlers.forEach((handler, link) => {
      link.removeEventListener('click', handler);
    });
    this.linkClickHandlers.clear();

    const modal = document.getElementById('impressum-modal');
    const impressumLinks = document.querySelectorAll('.impressum-link');

    if (!modal) return;

    impressumLinks.forEach(link => {
      const clickHandler = e => {
        e.stopPropagation();

        document.querySelectorAll('.contact-menu').forEach(menu => {
          menu.classList.remove('open');
        });

        modal.style.display = 'flex';
        setTimeout(() => modal.classList.add('open'), 10);
      };
      link.addEventListener('click', clickHandler);
      this.linkClickHandlers.set(link, clickHandler);
    });

    this._setupCloseHandlers(modal);
  }

  _setupCloseHandlers(modal) {
    // Clean up old handlers first
    this._cleanupCloseHandlers();

    const closeBtn = modal?.querySelector('.modal-close');

    const closeModal = () => {
      modal.classList.remove('open');
      setTimeout(() => {
        modal.style.display = 'none';
      }, 250);
    };

    this.closeButtonHandler = () => closeModal();
    closeBtn?.addEventListener('click', this.closeButtonHandler);

    this.modalClickHandler = e => {
      if (e.target === modal) {
        closeModal();
      }
    };
    modal.addEventListener('click', this.modalClickHandler);

    this.keydownHandler = e => {
      if (e.key === 'Escape' && modal.classList.contains('open')) {
        closeModal();
      }
    };
    document.addEventListener('keydown', this.keydownHandler);
  }

  _cleanupCloseHandlers() {
    const modal = document.getElementById('impressum-modal');
    const closeBtn = modal?.querySelector('.modal-close');

    if (this.closeButtonHandler && closeBtn) {
      closeBtn.removeEventListener('click', this.closeButtonHandler);
      this.closeButtonHandler = null;
    }
    if (this.modalClickHandler && modal) {
      modal.removeEventListener('click', this.modalClickHandler);
      this.modalClickHandler = null;
    }
    if (this.keydownHandler) {
      document.removeEventListener('keydown', this.keydownHandler);
      this.keydownHandler = null;
    }
  }
}

// ============================================================================
// Datenschutz Modal Handler
// ============================================================================

class DatenschutzModalHandler {
  constructor(templateBuilder) {
    this.templateBuilder = templateBuilder;
    this.linkClickHandlers = new Map();
    this.languageChangeHandler = null;
    this.closeButtonHandler = null;
    this.modalClickHandler = null;
    this.keydownHandler = null;
  }

  setup() {
    this._setupModal();

    // Rebuild modal content when language changes
    this.languageChangeHandler = () => {
      this._rebuildModal();
    };
    window.addEventListener('languageChanged', this.languageChangeHandler);
  }

  cleanup() {
    // Remove language change listener
    if (this.languageChangeHandler) {
      window.removeEventListener('languageChanged', this.languageChangeHandler);
      this.languageChangeHandler = null;
    }

    // Remove modal listeners
    this._cleanupCloseHandlers();
    this.linkClickHandlers.clear();
  }

  _setupModal() {
    // Clean up old links first
    this.linkClickHandlers.forEach((handler, link) => {
      link.removeEventListener('click', handler);
    });
    this.linkClickHandlers.clear();

    const modal = document.getElementById('datenschutz-modal');
    const datenschutzLinks = document.querySelectorAll('.datenschutz-link');

    if (!modal) return;

    datenschutzLinks.forEach(link => {
      const clickHandler = e => {
        e.stopPropagation();

        document.querySelectorAll('.contact-menu').forEach(menu => {
          menu.classList.remove('open');
        });

        modal.style.display = 'flex';
        setTimeout(() => modal.classList.add('open'), 10);
      };
      link.addEventListener('click', clickHandler);
      this.linkClickHandlers.set(link, clickHandler);
    });

    this._setupCloseHandlers(modal);
  }

  _setupCloseHandlers(modal) {
    // Clean up old handlers first
    this._cleanupCloseHandlers();

    const closeBtn = modal?.querySelector('.modal-close');

    const closeModal = () => {
      modal.classList.remove('open');
      setTimeout(() => {
        modal.style.display = 'none';
      }, 250);
    };

    this.closeButtonHandler = () => closeModal();
    closeBtn?.addEventListener('click', this.closeButtonHandler);

    this.modalClickHandler = e => {
      if (e.target === modal) {
        closeModal();
      }
    };
    modal.addEventListener('click', this.modalClickHandler);

    this.keydownHandler = e => {
      if (e.key === 'Escape' && modal.classList.contains('open')) {
        closeModal();
      }
    };
    document.addEventListener('keydown', this.keydownHandler);
  }

  _cleanupCloseHandlers() {
    const modal = document.getElementById('datenschutz-modal');
    const closeBtn = modal?.querySelector('.modal-close');

    if (this.closeButtonHandler && closeBtn) {
      closeBtn.removeEventListener('click', this.closeButtonHandler);
      this.closeButtonHandler = null;
    }
    if (this.modalClickHandler && modal) {
      modal.removeEventListener('click', this.modalClickHandler);
      this.modalClickHandler = null;
    }
    if (this.keydownHandler) {
      document.removeEventListener('keydown', this.keydownHandler);
      this.keydownHandler = null;
    }
  }

  _rebuildModal() {
    const modal = document.getElementById('datenschutz-modal');
    if (!modal) return;
    langManager.updatePageText();
  }
}

// ============================================================================
// Layout Detection Handler
// ============================================================================

class LayoutDetectionHandler {
  constructor() {
    this.resizeTimer = null;
    this.scheduleUpdate = null;
    this.orientationChangeHandler = null;
  }

  setup() {
    this._updateLayout();

    // Create the handler with proper scope binding
    this.scheduleUpdate = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this._updateLayout(), 100);
    };

    this.orientationChangeHandler = () => {
      setTimeout(() => this._updateLayout(), 200);
    };

    window.addEventListener('resize', this.scheduleUpdate);
    window.visualViewport?.addEventListener('resize', this.scheduleUpdate);
    window.addEventListener('orientationchange', this.orientationChangeHandler);
  }

  cleanup() {
    if (this.scheduleUpdate) {
      window.removeEventListener('resize', this.scheduleUpdate);
      window.visualViewport?.removeEventListener('resize', this.scheduleUpdate);
      this.scheduleUpdate = null;
    }
    if (this.orientationChangeHandler) {
      window.removeEventListener('orientationchange', this.orientationChangeHandler);
      this.orientationChangeHandler = null;
    }
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
  }

  _updateLayout() {
    const aspectRatio = window.innerWidth / window.innerHeight;
    const isIntermediate = aspectRatio <= INTERMEDIATE_ASPECT_RATIO;

    const navbar = document.querySelector('.nav-sidebar');
    if (!navbar) return;

    if (isIntermediate) {
      document.body.classList.add('horizontal-nav');
      const navbarHeight = navbar.offsetHeight;
      document.documentElement.style.setProperty('--navbar-height', `${navbarHeight}px`);
    } else {
      document.body.classList.remove('horizontal-nav');
      document.documentElement.style.removeProperty('--navbar-height');
    }
  }
}

// ============================================================================
// Navigation Manager
// ============================================================================

class NavigationManager {
  constructor() {
    this.isMobile = window.__IS_MOBILE ?? window.matchMedia('(pointer: coarse)').matches;
    this.templateBuilder = new NavigationTemplateBuilder();
    this.imagePreloader = new NavigationImagePreloader();
    this.sectionManager = new SectionManager();
    this.homePageVisibilityManager = new HomePageVisibilityManager(this.sectionManager);
    this.sectionIconsHandler = new SectionIconsHandler(this.sectionManager);
    this.mobileHomeButtonHandler = new MobileHomeButtonHandler();
    this.languageSwitcher = new LanguageSwitcher();
    this.contactMenuHandler = new ContactMenuHandler();
    this.impressumModalHandler = new ImpressumModalHandler(this.templateBuilder);
    this.datenschutzModalHandler = new DatenschutzModalHandler(this.templateBuilder);
    this.layoutDetectionHandler = new LayoutDetectionHandler();
    this._scrollHandler = null;
  }

  setup() {
    const container = document.getElementById('navigation-container');
    if (!container) return;

    this._injectHTML(container);
    this._showNavigation();

    this.imagePreloader.preload().catch(() => {});
    langManager.updatePageText();

    if (this.isMobile) {
      this.mobileHomeButtonHandler.setup();
    } else {
      this.sectionIconsHandler.setup();
      this.layoutDetectionHandler.setup();
    }

    // Setup home page visibility manager for all devices (handles logo visibility globally)
    this.homePageVisibilityManager.setup();

    this.languageSwitcher.setup();
    this.contactMenuHandler.setup();
    this.impressumModalHandler.setup();
    this.datenschutzModalHandler.setup();
    this._setupHideOnScroll();
  }

  cleanup() {
    // Clean up all handlers to prevent event listener accumulation
    if (this.isMobile) {
      this.mobileHomeButtonHandler.cleanup?.();
    } else {
      this.sectionIconsHandler.cleanup?.();
      this.layoutDetectionHandler.cleanup?.();
    }

    this.homePageVisibilityManager.cleanup?.();
    this.languageSwitcher.cleanup?.();
    this.contactMenuHandler.cleanup?.();
    this.impressumModalHandler.cleanup?.();
    this.datenschutzModalHandler.cleanup?.();
    this._cleanupHideOnScroll();
  }

  _injectHTML(container) {
    const isMobileDevice = window.__IS_MOBILE ?? window.matchMedia('(pointer: coarse)').matches;
    document.body.classList.remove('is-mobile', 'is-desktop');
    if (isMobileDevice) {
      container.innerHTML = this.templateBuilder.buildMobileHTML();
      document.body.classList.add('is-mobile');
    } else {
      container.innerHTML = this.templateBuilder.buildDesktopHTML();
      document.body.classList.add('is-desktop');
    }
  }

  _showNavigation() {
    const revealNavigation = () => {
      const navbar = document.querySelector('.nav-sidebar');
      const utilities = document.querySelector('.nav-utilities');
      if (navbar) navbar.classList.add('nav-ready');
      if (utilities) utilities.classList.add('nav-ready');

      // Debug: watch for unexpected navbar changes
      // if (navbar && !navbar.navbarObserver) {
      //   const observer = new MutationObserver(mutations => {
      //     mutations.forEach(mutation => {
      //       if (mutation.type === 'attributes') {
      //         log(
      //           '[DEBUG] Navbar attribute changed:',
      //           mutation.attributeName,
      //           'classList:',
      //           Array.from(navbar.classList),
      //           'opacity:',
      //           navbar.style.opacity
      //         );
      //       }
      //     });
      //   });
      //   observer.observe(navbar, { attributes: true, attributeFilter: ['class', 'style'] });
      //   navbar.navbarObserver = observer;
      // }
    };

    const revealOnNextFrame = () => requestAnimationFrame(revealNavigation);
    const isHomePage = document.body.classList.contains('page-home');

    if (!isHomePage) {
      revealOnNextFrame();
      return;
    }

    let revealed = false;
    const revealOnce = () => {
      if (revealed) return;
      revealed = true;
      revealOnNextFrame();
    };

    const logoOverlay = document.getElementById('home-logo-overlay');
    if (logoOverlay?.classList.contains('open')) {
      revealOnce();
      return;
    }

    const onHomeLogoReady = () => {
      window.removeEventListener('home-logo-stage-ready', onHomeLogoReady);
      revealOnce();
    };

    window.addEventListener('home-logo-stage-ready', onHomeLogoReady);

    // Fallback: never block nav if the stage event fails for any reason.
    setTimeout(() => {
      window.removeEventListener('home-logo-stage-ready', onHomeLogoReady);
      revealOnce();
    }, 400);
  }

  // How it works:
  //   - Listens to scroll on `main` (the actual scrollable container),
  //     not window (which doesn't scroll because main has overflow-y:auto)
  //   - Hides nav when scrolling DOWN past a small threshold (8px)
  //   - Restores nav when scrolling back UP, or when near the top
  //   - Cleans up properly via cleanup()

  _setupHideOnScroll() {
    // Only relevant for mobile portrait — desktop nav is a sidebar
    if (!this.isMobile) return;

    // Only enable hide-on-scroll for game pages
    const GAME_PAGES = ['page-memory', 'page-plunge', 'page-simon', 'page-skyfall'];
    const isGamePage = GAME_PAGES.some(cls => document.body.classList.contains(cls));
    if (!isGamePage) return; // non-game pages: nav always visible

    const main = document.querySelector('main');
    if (!main) return;

    let lastScrollY = 0;
    const THRESHOLD = 8; // px — ignore tiny jitter

    this._scrollHandler = () => {
      const currentY = main.scrollTop;
      const delta = currentY - lastScrollY;

      if (Math.abs(delta) < THRESHOLD) return;

      if (delta > 0 && currentY > 40) {
        // Scrolling DOWN and not at the very top
        document.body.classList.add('nav-hidden');
      } else {
        // Scrolling UP, or snapped back near top
        document.body.classList.remove('nav-hidden');
      }

      lastScrollY = currentY;
    };

    main.addEventListener('scroll', this._scrollHandler, { passive: true });
  }

  _cleanupHideOnScroll() {
    const main = document.querySelector('main');
    if (main && this._scrollHandler) {
      main.removeEventListener('scroll', this._scrollHandler);
      this._scrollHandler = null;
    }
    document.body.classList.remove('nav-hidden');
  }
}
// ============================================================================
// Public API
// ============================================================================

let navigationManager = null;

export function setupNavigation() {
  navigationManager = new NavigationManager();
  navigationManager.setup();
}

export function cleanupNavigation() {
  if (navigationManager) {
    navigationManager.cleanup();
  }
}
